/* global DetectUserAgent */
export * from "react-device-detect";

import { browserName as detectedBrowserName } from "react-device-detect";

export const browserName =
  typeof DetectUserAgent !== "undefined" && DetectUserAgent.isTikTokBrowser() ? "TikTok" : detectedBrowserName;
